import { createFileRoute } from '@tanstack/react-router';

import { ScriptsOfWeek } from '@/view/pages/ScriptsOfWeek';

export const Route = createFileRoute('/_protected/$programId/roteiros-da-semana')({
  component: ScriptsOfWeek,
  context: (context): { title: string } => ({
    ...context,
    title: 'Roteiros da Semana',
  }),
});
